import { BatchStatus } from './batch-status';

export class BatchStatusResponse {
  batches: BatchStatus[];
  continuation: string;
}
